export enum PaymentType {
    PayPal = 'payPal',
    CreditCard = 'creditCard',
    DirectDebit = 'directDebit',
}
